<template>
  <div class="header">
    <div class="header__logo">
      <el-link href="https://timelyelectic.ca" target="_blank">
        <el-avatar shape="circle" size="large" :src="logoUrl" />
      </el-link>
    </div>
    <div class="header__title">{{title}}</div>
    <div class="header__user">
      <el-popover placement="left-start" trigger="hover" :content="username">
        <template #reference>
          <el-avatar shape="circle" size="default">
            <el-icon style="vertical-align: middle"><Avatar /></el-icon>
          </el-avatar>
        </template>
      </el-popover>
    </div>
    <div class="header__logout" title="Sign out" @click="logout">
      退出
    </div>
  </div>
</template>


<script>
// import { mapGetters } from "vuex";
import { Avatar } from '@element-plus/icons-vue'
export default {
  name: "Header",
  components: { Avatar },
  data() {
    return {
      title: "Timely Electric Management Consoles",
      logoUrl: require('@/assets/logo.png'),
      username: this.$store.getters.userInfo.nickname,
    }
  },
  computed: {
    // ...mapGetters([
    //   'userInfo',
    //   'avatar',
    // ])
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>


<style lang="scss" scoped>
@import "@/assets/variables.scss";

.header {
  position: relative;
  height: $header-height;
  border-bottom: 1px solid rgba(144, 147, 153, 0.2);
  background-color: $theme-color;
  z-index: 1;
}
.header__logo {
  position: absolute;
  // transform: translateY(15%);
  top: 15%;
  left: 50px;
}
.header__title {
  position: absolute;
  // transform: translateY(70%);
  top: 25%;
  left: 120px;
  font-size: 26px;
  font-weight: bold;
  color: black;
}
.header__user {
  position: absolute;
  // transform: translateY(50%);
  top: 20%;
  right: 100px;
  font-size: 30px;
  font-weight: normal;
}
.header__logout {
  position: absolute;
  // transform: translateY(20%);
  top: 30%;
  right: 40px;
  color: white;
  cursor: pointer;
}
.header__logo:hover, .header__user:hover, .header__logout:hover {
  background-color: $theme-color2;
}
</style>
